import React from 'react';
import { CAMPOS_ORDENACAO } from './constantes';
import { Campo, Painel, Selecao } from './estilos';

const ordemPadrao = (campo) => (campo === 'criadoEm' ? 'desc' : 'asc');

const PainelOrdenacao = ({ ordenarPor, ordem, onAplicar }) => {
  const campo = ordenarPor || 'criadoEm';
  const sentido = ordem || ordemPadrao(campo);

  return (
    <Painel aria-label="Ordenação do relatório">
      <Campo>
        Ordenar por
        <Selecao
          value={campo}
          onChange={(evento) =>
            onAplicar({ ordenarPor: evento.target.value, ordem: ordemPadrao(evento.target.value) })
          }
        >
          {CAMPOS_ORDENACAO.map(({ valor, rotulo }) => (
            <option key={valor} value={valor}>{rotulo}</option>
          ))}
        </Selecao>
      </Campo>

      <Campo>
        Sentido
        <Selecao value={sentido} onChange={(evento) => onAplicar({ ordenarPor: campo, ordem: evento.target.value })}>
          <option value="asc">Crescente</option>
          <option value="desc">Decrescente</option>
        </Selecao>
      </Campo>
    </Painel>
  );
};

export default PainelOrdenacao;
